import { useMutation } from "react-query";
import { setFleetCancellationStatus } from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

export function useSetFleetCancellationStatus() {
  return useMutation(setFleetCancellationStatus, {
    mutationKey: MUTATION_KEYS.setFleetCancellationStatus,

    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
